import React from 'react'
import { concatStyles } from 'utils'

interface IColorOptionProps {
  color: string
  selected?: boolean
  onClick: Function
}

const COLOR_OPTION_STYLES =
  'rounded border-2 border-solid h-6 cursor-pointer block w-full hover:border-actionable'
const DEFAULT_BORDER_COLOR_STYLES = 'border-transparent'
const SELECTED_BORDER_STYLES = 'border-accent'

export const ColorOption: React.FC<IColorOptionProps> = ({
  color,
  selected,
  onClick,
}) => {
  const handleOnClick = () => onClick?.(color)

  return (
    <button
      onClick={handleOnClick}
      style={{ backgroundColor: color }}
      className={concatStyles([
        COLOR_OPTION_STYLES,
        selected ? SELECTED_BORDER_STYLES : DEFAULT_BORDER_COLOR_STYLES,
      ])}
    />
  )
}
